import {apiSlice} from './apiSlice';
import {
    GetSharesParams,
    GetPurchasesParams,
    Purchase,
    Share,
    CreatePurchaseParams
} from '../../types/purchaseTypes';

export const purchaseApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getShares: builder.query<Share, GetSharesParams>({
            query: ({sharableType, sharableID}) => `/shares/?sharable_type=${sharableType}&sharable_id=${sharableID}`,
            providesTags: ['Share'],
        }),
        getPurchases: builder.query<Purchase[], GetPurchasesParams>({
            query: ({itemType, recipientType, recipientID}) => `/purchases/?recipient_type=${recipientType}&recipient_id=${recipientID}&item_type=${itemType}`,
            providesTags: ['Purchase', 'Share'],
        }),
        createPurchase: builder.mutation<void, CreatePurchaseParams>({
            query: (body) => ({
                url: '/purchases',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Purchase', 'Share']
        }),
    }),
});

export const {
    useGetSharesQuery,
    useGetPurchasesQuery,
    useCreatePurchaseMutation,
} = purchaseApi;

